import React from 'react';
import { Github, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-card/50 border-t border-border mt-auto">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            © 2025 Location Scout. All rights reserved.
          </div>
          <div className="flex items-center space-x-4">
            <a href="https://github.com/bO-05/" className="text-muted-foreground hover:text-foreground" target="_blank" rel="noopener noreferrer">
              <Github size={20} />
            </a>
            <a href="https://x.com/asynchronope/" className="text-muted-foreground hover:text-foreground" target="_blank" rel="noopener noreferrer">
              <Twitter size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;